
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground, PropsTable } from "docz";
import LinkButton from "../shared/components/LinkButton.js";
import Button from "../shared/components/Button.js";
import Text from "../shared/components/Text.js";
import Heading from "../shared/components/Heading.js";
import "../shared/css/index.css";

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"linkbutton"}}>{`LinkButton`}</MDXTag>
<MDXTag name="p" components={components}>{`LinkButton acepta tres props:`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`children`}</MDXTag>{`, que es obligatorio y el contenido que va a desplegar `}<MDXTag name="inlineCode" components={components} parentName="li">{`<LinkButton />`}</MDXTag>{`.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`to`}</MDXTag>{`, que es obligatorio y es una dirección de la página a dónde queremos navegar.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`className`}</MDXTag>{`, para agregar estilos personalizados. Opcional.`}</MDXTag>
</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="inlineCode" components={components} parentName="p">{`children`}</MDXTag>{` puede ser un texto plano o un componente como Text, Heading o Button, y lo cubre en componente `}<MDXTag name="inlineCode" components={components} parentName="p">{`<Link />`}</MDXTag>{` de `}<MDXTag name="inlineCode" components={components} parentName="p">{`@reach/router`}</MDXTag>{`.`}</MDXTag>
<Playground __position={0} __code={'<LinkButton to=\"/\">\n  <Text>Esto es un Texto con LinkButton</Text>\n</LinkButton>\n<LinkButton to=\"/\">\n  <Heading>Esto es un heading con LinkButton</Heading>\n</LinkButton>\n<LinkButton to=\"/\">\n  <Button>Esto es un botón con LinkButton</Button>\n</LinkButton>'} __scope={{props: this ? this.props : props,LinkButton,Button,Text,Heading}}>
  <LinkButton to='/'>
    <Text>Esto es un Texto con LinkButton</Text>
  </LinkButton>
  <LinkButton to='/'>
    <Heading>Esto es un heading con LinkButton</Heading>
  </LinkButton>
  <LinkButton to='/'>
    <Button>Esto es un botón con LinkButton</Button>
  </LinkButton>
</Playground>
<PropsTable of={LinkButton} />
           </MDXTag>
  }
}
  